export default "__VITE_ASSET__D67cPIa9__"